import request from "@/utils/request";

// 采购订单

export function getPurchaseOrderPage(params) {
    return request.post('/supply/purchaseOrder/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function getPurchaseOrder(id) {
    return request.get(`/supply/purchaseOrder/get/${id}`)
        .then(res => res.data);
}

export function getPurchaseOrderProductList(id) {
    return request.get(`/supply/purchaseOrder/productList/${id}`)
        .then(res => res.data);
}

export function getPurchaseOrderAddProductPage(params) {
    return request.post('/supply/purchaseOrder/page/add/product', params)
        .then(res => res.data);
}

export function importPurchaseOrderProduct(attId, params) {
    return request.post(`/supply/purchaseOrder/import/product?attachmentId=${attId}`, params);
}

export function savePurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/save`, params);
}

export function saveAndAuditPurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/add/arraignment`, params);
}

export function updateAndAuditPurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/update/arraignment`, params);
}

export function auditPurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/arraignment`, params);
}

export function auditPassPurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/review/yes`, params);
}

export function auditFailPurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/review/no`, params);
}

export function cancelPurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/abolished`, params);
}

export function purchasePurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/under`, params);
}

export function endDeliveryPurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/end/delivery`, params);
}

export function createDeliveryOrder(params) {
    return request.post(`/supply/purchaseOrder/create/delivery/note`, params);
}

export function fastInboundPurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/fast/inbound`, params);
}

export function createPurchaseChangeOrder(params) {
    return request.post(`/supply/purchaseOrder/create/purchase/change`, params);
}

export function getPurchaseOrderDelivery(id) {
    return request.get(`/supply/purchaseOrder/deliveryNoteList/${id}`)
        .then(res => res.data);
}

export function getPurchaseOrderInbound(id) {
    return request.get(`/supply/purchaseOrder/inboundList/${id}`)
        .then(res => res.data);
}

export function updatePurchaseOrder(params) {
    return request.post(`/supply/purchaseOrder/update`, params);
}

// 交货单

export function getDeliveryOrderPage(params) {
    return request.post(`/supply/purchaseDeliveryNote/page`, params)
        .then(res => res.data);
}

export function cancelDeliveryOrder(params) {
    return request.post(`/supply/purchaseDeliveryNote/abolished`, params);
}

export function updateDeliveryOrderActualDeliveryDate(params) {
    return request.post(`/supply/purchaseDeliveryNote/update/date`, params);
}

export function getDeliveryOrderList(id) {
    return request.get(`/supply/purchaseDeliveryNote/inboundList/${id}`)
        .then(res => res.data);
}

export function getDeliveryOrder(id) {
    return request.get(`/supply/purchaseDeliveryNote/${id}`)
        .then(res => res.data);
}

export function getDeliveryOrderProductList(id) {
    return request.get(`/supply/purchaseDeliveryNote/productList/${id}`)
        .then(res => res.data);
}

export function updateDeliveryOrder(params) {
    return request.post(`/supply/purchaseDeliveryNote/update`, params);
}

export function getPurchaseOrderProcessList(id) {
    return request.get(`/supply/purchaseOrder/processNodeList/${id}`)
        .then(res => res.data);
}

// 采购变更单

export function getPurchaseOrderChangePage(params) {
    return request.post('/supply/purchaseOrderChange/page', params)
        .then(res => res.data);
}

export function getSupplierPage(params) {
    return request.post('/supply/supplier/page', params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function addSupplier(params) {
    return request.post('/supply/supplier', params)
        .then((res) => {
            return Promise.resolve(res);
        });
}

export function editSupplier(params) {
    return request.put('/supply/supplier', params)
        .then((res) => {
            return Promise.resolve(res);
        });
}

export function getSupplierDetail(id) {
    return request.get(`/supply/supplier/${id}`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function getQuoteInfo(code, params) {
    return request.post(`/supply/supplier/quote/${code}`, params)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function ableSupplier(type, ids) {
    return request.put(`/supply/supplier/${type}?ids=${ids}`)
        .then((res) => {
            return Promise.resolve(res);
        })
}

export function deleteSupplier(ids) {
    return request.delete(`/supply/supplier?ids=${ids}`)
        .then((res) => {
            return Promise.resolve(res);
        })
}

export function getSupplierOptions(isActive = true) {
    return request.get(`/supply/supplier/select?isEnable=${isActive}`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function getSupplierByCode(code) {
    return request.get(`/supply/supplier/select/${code}`)
        .then(res => res.data);
}

export function importSupplier(attId) {
    return request.post(`/supply/supplier/import/supplier?attachmentId=${attId}`)
        .then((res) => {
            return Promise.resolve(res);
        });
}

export function importSupplierQuotedPrice(attId) {
    return request.post(`/supply/supplier/import/supplier/quote?attachmentId=${attId}`)
        .then((res) => {
            return Promise.resolve(res);
        });
}

export function supplierQuoted(params) {
    return request.post(`/supply/supplier/quote`, params)
        .then((res) => {
            return Promise.resolve(res);
        });
}

export function quotedHistory(code, sku) {
    return request.get(`/supply/supplier/quote/history/${code}/${sku}`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function getQuotedLog(code) {
    return request.get(`/supply/supplier/quote/log/${code}`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function deleteQuotedHistory(ids) {
    return request.delete(`/supply/supplier/history?ids=${ids}`)
        .then((res) => {
            return Promise.resolve(res);
        })
}

export function checkSupplierName(name, id) {
    return request.get(`/supply/supplier/checkSupplierName?id=${id}&name=${name}`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

export function checkSupplierCode(code, id) {
    return request.get(`/supply/supplier/checkSupplierCode?id=${id}&code=${code}`)
        .then((res) => {
            return Promise.resolve(res.data);
        })
}

// 采购计划- 主页面
export function getPurchasePlanPage(params) {
    return request.post('/supply/purchasePlan/page', params)
        .then(res => res.data);
}


// 采购计划- 查询产品
export function getPurchasePlanPageAddProduct(params) {
    return request.post('/supply/purchasePlan/page/add/product', params)
        .then(res => res.data);
}

// 采购计划- 导入产品
export function purchasePlanImportProduct(attachmentId, params) {
    return request.post('/supply/purchasePlan/import/product?attachmentId=' + attachmentId, params)
        .then(res => res);
}

// 采购计划- 审批不通过
export function purchasePlanReviewNo(params) {
    return request.post('/supply/purchasePlan/review/no', params)
        .then(res => res.data);
}

// 采购计划- 审批通过
export function purchasePlanReviewYes(params) {
    return request.post('/supply/purchasePlan/review/yes', params)
        .then(res => res.data);
}

// 采购计划- 新增-保存为草稿
export function addPurchasePlan(params) {
    return request.post('/supply/purchasePlan', params)
        .then(res => res.data);
}

// 采购计划-新增- 确定
export function purchasePlanAddArraignment(params) {
    return request.post('/supply/purchasePlan/add/arraignment', params)
        .then(res => res.data);
}

// 采购计划- 修改
export function editPurchasePlan(params) {
    return request.put('/supply/purchasePlan', params)
        .then(res => res.data);
}

// 采购计划- 提审
export function purchasePlanArraignment(params) {
    return request.post('/supply/purchasePlan/arraignment', params)
        .then(res => res.data);
}

// 采购计划- 删除
export function deletePurchasePlan(params) {
    return request.delete(`/supply/purchasePlan`, {data:params})
        .then(res => res.data);
}

// 采购计划- 作废
export function purchasePlanPushAbolished(params) {
    return request.post('/supply/purchasePlan/abolished', params)
        .then(res => res.data);
}

// 采购计划- 分单-查询
export function purchasePlanSplitOrder(params) {
    return request.post('/supply/purchasePlan/split/order', params)
        .then(res => res.data);
}

// 采购计划- 分单-生成采购订单
export function purchasePlanGenerateOrder(params) {
    return request.post('/supply/purchasePlan/generate/order', params)
        .then(res => res.data);
}

// 采购计划- 主页面修改备注
export function purchasePlanUpdateInfo(params) {
    return request.put('/supply/purchasePlan/update/main/memo', params)
        .then(res => res.data);
}

// 采购计划- 主页面修改上传文件
export function purchasePlanUpdateAttachment(params) {
    return request.put('/supply/purchasePlan/update/main/attachment', params)
        .then(res => res.data);
}

// 采购计划- 供应商查询
export function purchasePlanQuerySupplier(params) {
    return request.post('/supply/purchasePlan/query/supplier', params)
        .then(res => res.data);
}

// 采购计划- 更新业务配置参数
export function updateBusinessConfiguration(params) {
    return request.put('/supply/businessConfiguration', params)
        .then(res => res.data);
}

// 采购计划- 查询 业务配置参数
export function queryBusinessConfiguration(params) {
    return request.get('/supply/businessConfiguration/query', params)
        .then(res => res.data);
}

// 采购计划- 查询 审批设置参数值查询
export function queryReviewSetting(params) {
    return request.get('/supply/businessConfiguration/queryReviewSetting?name='+params.name)
        .then(res => res.data);
}

